import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { AutocompleteInput, required, TextInput } from 'react-admin';
import { disableAutofillOptions } from '../../helper';
import useStyles from '../../QuickActions/styles';
import { usStateOptions } from '../../UsStates';

const LicenseForm = () => {
  const classes = useStyles();

  return (
    <Box>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <Grid item xs={12} sm={6} md={4}>
          <TextInput
            source="license.license_plate_number"
            label="License plate"
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="License plate state"
            source="license.license_plate_state"
            choices={usStateOptions}
            validate={[required()]}
            options={disableAutofillOptions}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextInput source="license.color" label="Color" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LicenseForm;
